/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect, useRef } from 'react';
import { getName, getUser, isBotLoggedIn, getBotSettingItem, logout } from '../AuthService'
import { FiChevronDown, FiSettings, FiBookOpen, FiHelpCircle, FiLogOut, FiUser, FiMessageSquare, FiCodesandbox, FiLayout, FiTag, FiThermometer, FiMenu } from 'react-icons/fi';
import * as default_data from '../config.js'
import { Stack, Typography, Menu, MenuItem, ListItemIcon, ListItemText, MenuList, Box, IconButton, useTheme } from '@mui/material';
import { SVGLogo } from './Components/SVGLogo.js';
import { Navigate } from 'react-router-dom';
import { GrCompare } from "react-icons/gr";


const HeaderLogged = ({ 
  currentMode, 
  switchMode, 
  openModal, 
  openSidebar,
  chatInput,
  setChatInput,
  setSettingDrawerOpen,
  setSettingsTabValue,
}) => {
  const [paid, setPaid] = useState(false);

  const iconSize = '14px'
  const listItemIconStyle = { minWidth: '30px !important', color: 'white' }
  const listItemStyle = { color: 'white', '&:hover': {color:'white', backgroundImage: 'rgba(0,0,0,0.3)'} }

  const theme = useTheme();
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const buttonRef = useRef(null);
  const [firstname, setName] = useState("");

  useEffect(() => {
    var user = getUser()
    setPaid(user.paid)
    setName(getName())
  }, []);

  const switchChatInput = (input) => {  
    setChatInput(input);
    localStorage.setItem('chatInput', input);
  }

  function call_logout() {
    logout()
  }
  const getWelcomeTextColor = () => {
    // check if the user is on / or dashboard
    if (window.location.pathname === "/" || window.location.pathname === "/dashboard" || window.location.pathname === "/bot") {
      return theme.palette.text.primary
    } else {
      return 'white'
    }
  }

  return (
    <div> 
  {
    isBotLoggedIn() && getBotSettingItem('hide_menu_bar') === true ? 
    '' :
  <div className="header_wrapper">
    <Box display={{ xs: 'block', md: 'none'}} padding={{ xs: 0, mobile: 1}}>
      <Stack direction="row" spacing={1} flexWrap={'nowrap'}>
        <IconButton onClick={()=>{openSidebar(true)}} >
          <FiMenu size={24} />
        </IconButton>
        <Stack direction="row" spacing={1} flexWrap={'nowrap'} visibility={'hidden'}>
          <Typography display={{ xs: 'none', sm: 'block'}} variant="body1">Welcome</Typography>
          <Typography variant="body1">{firstname}</Typography>
        </Stack>
      </Stack>
    </Box>
    <div className="header_logo">
      <a href="/dashboard"><img src="logo-menu.png" alt="Ask Sage" /></a>
    </div>
    <div className="header_inline">
      <div className="header_block">
        <button ref={buttonRef} className="buttonNoBorder" onClick={handleClick}>
          <Stack direction="row" spacing={1} flexWrap={'nowrap'}>
            <Typography color={getWelcomeTextColor()} display={{ xs: 'none', sm: 'block'}} variant="body1">Welcome</Typography>
            <Typography color={getWelcomeTextColor()} variant="body1">{firstname}</Typography>
            <FiChevronDown color={getWelcomeTextColor()} style={{marginTop: 4}}/>
          </Stack>
        </button>
        {open && (
          <Menu
            id={'account-menu'}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            sx={{
              '& .MuiPaper-root': {
                backgroundColor: '#121212',
                backgroundImage: 'none',
                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
              }
            }}
          >
            <MenuList dense>
              { currentMode === null || currentMode === undefined ? 
                <MenuItem component={'a'} href={'/dashboard'} sx={listItemStyle}>
                  <ListItemIcon sx={listItemIconStyle}>
                    <FiLayout size={iconSize}/>
                  </ListItemIcon>
                  <ListItemText primary="Back to Chat" />
                </MenuItem>         
              : ''}
              {setSettingDrawerOpen &&
                <MenuItem 
                  onClick={()=>{
                    setAnchorEl(null)
                    setSettingDrawerOpen(true)
                    setSettingsTabValue('tokens')
                  }} 
                  sx={listItemStyle}
                >
                  <ListItemIcon sx={listItemIconStyle}>
                    <FiTag size={iconSize}/>
                  </ListItemIcon>
                  <ListItemText primary="Subscription" />
                </MenuItem>
              }
              { paid == true ? 
                <MenuItem 
                  component={'a'}
                  href={'/workbook'}
                  rel="noopener"
                  sx={listItemStyle}
                >
                  <ListItemIcon sx={listItemIconStyle}>
                    <FiBookOpen size={iconSize}/>
                  </ListItemIcon>
                  <ListItemText primary="Workbook" />
                </MenuItem>
               : ''}
               { paid === true && (
                  <MenuItem 
                    component={'a'}
                    href={'/model-comparison'}
                    rel="noopener"
                    sx={listItemStyle}
                  >
                    <ListItemIcon sx={listItemIconStyle}>
                      <GrCompare size={iconSize}/>
                    </ListItemIcon>
                    <ListItemText primary="Model Comparison" />
                  </MenuItem>
               )}
              <MenuItem component={'a'} href={'/update'} sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <FiUser size={iconSize}/>
                </ListItemIcon>
                <ListItemText primary="Account" />
              </MenuItem>
              {setSettingDrawerOpen &&
                <MenuItem 
                  onClick={()=>{
                    setAnchorEl(null)
                    setSettingDrawerOpen(true)
                    setSettingsTabValue('customization')
                  }} 
                  sx={listItemStyle}
                >
                  <ListItemIcon sx={listItemIconStyle}>
                    <FiSettings size={iconSize}/>
                  </ListItemIcon>
                  <ListItemText primary="Settings" />
                </MenuItem>
              }   
              { currentMode !== null && currentMode !== undefined ?
                <MenuItem onClick={openModal} sx={listItemStyle}>
                  <ListItemIcon sx={listItemIconStyle}>
                    <FiHelpCircle size={iconSize}/>
                  </ListItemIcon>
                  <ListItemText primary="Help" />
                </MenuItem>
              : '' }
              { default_data.default_block_discord === true ? '' : 
                <MenuItem 
                  component={'a'}
                  href="https://discord.gg/upxuAdNvjY"
                  target="_blank"
                  rel="noopener"
                  sx={listItemStyle}
                >
                  <ListItemIcon sx={listItemIconStyle}>
                    <FiMessageSquare size={iconSize}/>
                  </ListItemIcon>
                  <ListItemText primary="Discord" />
                </MenuItem>
              }
              <MenuItem onClick={call_logout} sx={listItemStyle}>
                <ListItemIcon sx={listItemIconStyle}>
                  <FiLogOut size={iconSize}/>
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </MenuItem>
              {/* <button variant="light" onClick={call_logout}>Logout <FiLogOut /></button> */}
            </MenuList>
          </Menu>
        )}
      </div>
    </div>
</div>
      }
      </div>)
}


export default HeaderLogged